/** Ruta comparable con un smCode: sin query string ni barra final ('/empresas/' = '/empresas'). */
export const normalizePath = (path?: string) =>
  (path || '').split('?')[0].replace(/\/+$/, '') || '/';

/** El submenú da acceso solo a su propia ruta (no a las que empiezan igual). */
export const isSamePath = (smCode?: string, path?: string) =>
  !!smCode && normalizePath(smCode) === normalizePath(path);

export const getPermission = (loggedData: any) => {
  if (!loggedData?.subMenus?.length) return null;

  // inicio: entra cualquier usuario con al menos un submenú, salvo que tenga el dashboard bloqueado
  if (normalizePath(loggedData?.path) === '/') return loggedData?.uDashboardAccess !== 2;

  return loggedData.subMenus.some((x) => isSamePath(x?.smCode, loggedData?.path));
};
